import { render, staticRenderFns } from "./ActionButtonEdit.vue?vue&type=template&id=88002dec&scoped=true&"
import script from "./ActionButtonEdit.vue?vue&type=script&lang=js&"
export * from "./ActionButtonEdit.vue?vue&type=script&lang=js&"
import style0 from "./ActionButton.scss?vue&type=style&index=0&id=88002dec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88002dec",
  null
  
)

export default component.exports